export function currencyLocale(currency: string): string {
  switch (currency.toLowerCase()) {
    case "eur":
      return "de";
    case "sek":
      return "sv";
    default:
      return "en";
  }
}
